// extracted by mini-css-extract-plugin
export default {"flexBaseWidth":"M8tZqqI8pGcvDzKoNJeU","avatar":"XUCx9VSwS0HzlEK7OZOg","link":"tZJtXyJKPZwVhIw7UgTg","email":"STjMsHJMUw5P22RC33ho"};